import React from 'react';
import Banner from '../components/about/banner';
import Whychoose from '../components/about/whychoose';

function aboutpage() {
  return (
    <div>
       <Banner/>
       <Whychoose/>
    </div>
  )
}

export default aboutpage